import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Textarea,
  Text,
} from '@chakra-ui/react';
import { Avatar } from 'antd';
import { useState } from 'react';
import { BsPlusCircle } from 'react-icons/bs';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { mutateFunction } from '../../libs/apis';
import BrandButton from '../brandButton/BrandButton';
import { CustomToast } from '../toast/CustomToast';

const CreateConnectionModal = ({ isOpen, onClose, message, setMessage, user, onCompleteAction }) => {
  const loggedInUserId = useSelector((state) => state?.user?.userInfo?.id);
  const userInfo = useSelector((state) => state?.user?.userInfo);
  const { addToast } = CustomToast();

  const { mutate, isLoading } = useMutation(mutateFunction);

  const handleSubmit = () => {
    mutate(
      {
        key: `users/${loggedInUserId}/connect/${user.id}`,
        method: 'post',
        data: {
          message: message || null
        },
      },
      {
        onSuccess(res) {
          addToast(res);
          onCompleteAction(user.id, 'Connection Request Sent');
          user.connectionStatus = 'Connection Request Sent';
          setTimeout(() => {
            onClose()
          }, 2000)
        },
      },
    );
  };


  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent
        w={{ base: '90vw', sm: '400px', md: '500px' }}
        maxW={{ base: '95vw', sm: '400px', md: '500px' }}
        mx={{ base: 2, sm: 'auto' }}
        px={{ base: 2, sm: 0 }}
      >
        <ModalHeader fontSize={{ base: 'md' }}>
          <div className='flex border-b py-2 flex-wrap gap-2 items-center'>
            <Avatar
              borderRadius="1000"
              name={`${user?.first_name} ${user?.last_name}`}
              src={user?.profile_image}
              size={"sm"}
            />
            <Text fontSize={{ base: 'lg' }}>
              Connect with {user?.first_name || 'the user'}
            </Text>
          </div>
        </ModalHeader>
        <ModalBody pb={4}>
          <FormControl>
            <FormLabel fontSize={{ base: 'sm', sm: 'md' }}>
              Start a conversation with {user?.first_name || 'the user'}. Share something about you or your company(s) (optional)
            </FormLabel>
            <Textarea
              placeholder={`Hi! My name is ${userInfo?.firstName || 'Kaya'} ${userInfo?.lastName || ''} and here's a little about me`}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={4}
              fontSize={{ base: 'sm', sm: 'md' }}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button
            variant="ghost"
            mr={3}
            onClick={onClose}
            fontSize={{ base: 'sm', sm: 'md' }}
          >
            Cancel
          </Button>
          <BrandButton
            fontSize="13px"
            color="#000"
            bg="#C7DFF0"
            borderColor="#C7DFF0"
            icon={<BsPlusCircle className="text-[#000] text-lg" />}
            isLoading={isLoading}
            text={`Connect with ${user?.first_name || 'the user'}`}
            w="full"
            maxW="400px"
            onClick={handleSubmit}
          />
          {/* <Button
            colorScheme="brand.primary"
            onClick={handleSubmit}
            isLoading={isLoading}
            fontSize={{ base: 'sm', sm: 'md' }}
          >
            Connect with {user?.first_name || 'the user'}
          </Button> */}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CreateConnectionModal;
